// extracted by mini-css-extract-plugin
export default {"main":"PortfolioPage_main__ZVQkB"};